import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, catchError, of } from 'rxjs';
import { ServiceConstant } from '../utils/service-constant.util';

@Injectable({
  providedIn: 'root',
})
export class DeviceService {
  httpClient = inject(HttpClient);

  constructor() {}

  getDevices(): Observable<any> {
    return this.httpClient.get<any>(ServiceConstant.apiUrl + '/restaurants/devices').pipe(
      catchError((error) => {
        console.error('Error fetching zones:', error);
        return of(error);
      }),
    );
  }
}
